import React from "react";
import { Redirect } from "react-router-dom";
import FormChangePassword from "./components/FormChangePassword";
import Carousel from "./components/Carousel";

const ChangePassword: React.FC = () => {
  const isDev = process.env.REACT_APP_ALLOW_LOCAL_LOGIN === 'true' ||
                (process.env.REACT_APP_ALLOW_LOCAL_LOGIN !== 'false' && window.location.hostname === 'localhost');

  if (!isDev) {
    return <Redirect to="/" />;
  }

  return (
    <React.Fragment>
      <div className="wrapper-login">
        <div className="row row--vCenter">
          <div className="col--2 signIn fullHeight">
            <div className="signIn__container desktop-only">
              <h1 className="signIn__title">Sign in</h1>
              <p className="signIn__text">Please create a new password</p>
              <FormChangePassword />
            </div>
          </div>
          <Carousel />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ChangePassword;
